import { render, staticRenderFns } from "./LeaveTab.vue?vue&type=template&id=5970e634"
import script from "./LeaveTab.vue?vue&type=script&lang=js"
export * from "./LeaveTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports